import { useEffect, useMemo } from 'react';

import { useSelector } from 'react-redux';

import { userSelector } from 'store/user/selectors';
import appsignal from 'utils/appsignal';

import { isLoginAsSelector } from '../../store/auth/selectors';

export function useAppsignalAdminContext() {
  const tags = useTags();

  useEffect(() => {
    appsignal.addDecorator((span) => {
      return span.setTags(tags);
    });
  }, [tags]);
}

function useTags() {
  const user = useSelector(userSelector);
  const isOverriding = useSelector(isLoginAsSelector);

  return useMemo(() => getTags(user, isOverriding), [user, isOverriding]);
}

function getTags(user, isOverriding) {
  const tags = {};

  if (user) {
    tags.email = user.email;
    tags.firstName = user.firstName;
    tags.lastName = user.lastName;
    tags.acc = user.currentAccount?.id;
    tags.accType = user.currentAccount.type;
  }

  if (isOverriding) {
    tags.isOverriding = isOverriding;
  }

  return tags;
}
